import { useLocation } from "react-router";
import { useMySubscription } from "@/hooks/queries/useMySubscription";
import { SURETY_PLAN_NAME } from "@/lib/domain-constants";

/** Si la pantalla es del portal Fianzas: por el plan, o un admin mirando la demo. */
export function useSuretyMode() {
  const { pathname } = useLocation();
  const { data: subscription } = useMySubscription();
  return (
    subscription?.planKey === SURETY_PLAN_NAME || pathname.startsWith("/surety")
  );
}
